(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ss-text-block"] && !Shopify.designMode) return;
  try {
    // Pure CSS marquee; pas de JS nécessaire
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabs-collections"] && !Shopify.designMode) return;
  try {
    
(function () {
  function toArray(nodeList) { return Array.prototype.slice.call(nodeList || []); }

  function initTabsFor(wrap) {
    if (!wrap || wrap.__tabsBound) return;
    wrap.__tabsBound = true;

    var nav    = wrap.querySelector('.tabs-nav');
    var links  = toArray(nav ? nav.querySelectorAll('.tab-link') : []);
    var panels = toArray(wrap.querySelectorAll('.tab-panel'));
    if (!links.length || !panels.length) return;

    /* Centrage desktop seulement si ça ne déborde pas */
    if (nav) {
      var canCenter = nav.scrollWidth <= nav.clientWidth;
      nav.classList.toggle('centered-block', canCenter);
      if (!canCenter) nav.classList.remove('is-centered');
    }

    function getActiveIndex() {
      for (var i = 0; i < links.length; i++) {
        if (links[i].classList.contains('is-active')) return i;
      }
      return -1;
    }

    function activateTab(idx) {
      if (idx < 0 || idx >= links.length) return;
      var id = links[idx].getAttribute('data-tab');

      for (var i = 0; i < links.length; i++) {
        var on = i === idx;
        links[i].classList.toggle('is-active', on);
        links[i].setAttribute('aria-selected', on ? 'true' : 'false');
      }
      for (var j = 0; j < panels.length; j++) {
        panels[j].classList.toggle('is-active', panels[j].id === id);
      }

      var btn = links[idx];
      if (nav && btn && btn.scrollIntoView) {
        btn.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      }
      updateArrows();
    }

    if (nav) {
      nav.addEventListener('click', function (e) {
        var btn = e.target.closest ? e.target.closest('.tab-link') : null;
        if (!btn) return;
        var idx = parseInt(btn.getAttribute('data-index'), 10);
        if (!isNaN(idx)) activateTab(idx);
      });
    }

    var prev = wrap.querySelector('.tabs-arrow.prev');
    var next = wrap.querySelector('.tabs-arrow.next');

    function updateArrows() {
      if (!prev || !next) return;
      var i = getActiveIndex();
      prev.disabled = i <= 0;
      next.disabled = i >= links.length - 1;
    }

    if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); activateTab(getActiveIndex() - 1); });
    if (next) next.addEventListener('click', function (e) { e.preventDefault(); activateTab(getActiveIndex() + 1); });

    if (getActiveIndex() === -1) activateTab(0);
    updateArrows();

    var key = 'TC_' + (wrap.getAttribute('data-tabs') || '');
    window[key] = function (action) {
      if (action === 'prev') return activateTab(getActiveIndex() - 1);
      if (action === 'next') return activateTab(getActiveIndex() + 1);
      if (typeof action === 'number') return activateTab(action);
    };
  }

  function boot(root) {
    var scope = root || document;
    toArray(scope.querySelectorAll('[data-tabs]')).forEach(initTabsFor);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var container = e.target || (e.detail && document.getElementById('shopify-section-' + e.detail.sectionId));
    boot(container || document);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
